import React from 'react'

//import styles from './Label.module.css'

const HydrantLabel = ({
  ai: {
    attributes: { DESCRIPTION, HYDID },
  },
}) => (
  <div>
    <div>{DESCRIPTION || HYDID || 'No Description'}</div>
  </div>
)

export default HydrantLabel
